import api from '~/api'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  getOffer(_, id) {
    return api.get(`offers/${id}`)
  },
  createOffer(_, { data, options }) {
    return api.post('offers', data, options)
  },
  updateOffer(_, { data, options }) {
    return api.put(`offers/${data.id}`, data, options)
  },
  deleteOffer(_, id) {
    return api.delete(`offers/${id}`)
  },
  getRetailerOffers(_, id) {
    return api.get(`offers?retailer.id=${id}`)
  },
  offersRedeem(_, { data, options }) {
    return api.post(`/offers/${data.id}/redeem`, data, options)
  },

  uploadCouponsFile(_, { data, options }) {
    return api.post('/upload_coupon_file', data, options)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
